import { render, staticRenderFns } from "./referral-form.vue?vue&type=template&id=14066ef5&scoped=true"
import script from "./referral-form.vue?vue&type=script&lang=js"
export * from "./referral-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14066ef5",
  null
  
)

export default component.exports